export const techstack = {
    "html": "https://img.icons8.com/color/75/html-5--v1.png",
    "css": "https://img.icons8.com/color/75/css3.png",
    "js": "https://img.icons8.com/color/75/javascript--v1.png",
    "angular": "https://img.icons8.com/color/75/angularjs.png",
    "bootstrap": "https://img.icons8.com/color/75/bootstrap.png",
    "ts": "https://img.icons8.com/color/75/000000/typescript.png",
    "react": "https://img.icons8.com/color/75/000000/react-native.png",
    "postman": "https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/70/000000/external-postman-is-the-only-complete-api-development-environment-logo-shadow-tal-revivo.png",
    "jira": "https://img.icons8.com/color/75/000000/jira.png",
    "java": "https://img.icons8.com/color/75/000000/java-coffee-cup-logo--v1.png",
    "python": "https://img.icons8.com/color/75/000000/python--v1.png",
    "net": "https://img.icons8.com/color/75/000000/net-framework.png",
    "mysql": "https://img.icons8.com/color/75/000000/mysql-logo.png",
    "postgreSql": "https://img.icons8.com/color/75/000000/postgreesql.png",
    "tailwind": "https://img.icons8.com/color/75/000000/tailwind_css.png",
    "figma": "https://img.icons8.com/color/75/000000/figma--v1.png",
    "git": "https://img.icons8.com/color/75/000000/git.png",
    "vscode": "https://img.icons8.com/color/75/000000/visual-studio--v2.png"
}



